import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=798ef9c3&scoped=true&"
var script = {}
import style0 from "./errorPage.vue?vue&type=style&index=0&id=798ef9c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ef9c3",
  null
  
)

export default component.exports